<template>
  <div v-if="topbar.enabled" class="topbar" v-html="topbar.content">
  </div>
</template>

<script>
export default {
  props: {
    topbar: {
      default:() => ({}),
      type: Object
    }
  }
}
</script>

<style>
.topbar {
  width: 100%;
  min-height: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  z-index: 6;
  padding: 5px;
}
</style>